/* NW sengeguide: DOM-rettelser paa tilvalgene. Tilfoejet 28-08-2026.

   Tre ting, alle fordi renderingen ligger i 11 KB minificeret kode i nw-sg-8.js
   som vi ikke vil skrive om for at rette detaljer.

   1) MATERIALENAVN: nw-sg-8.js skriver ordet "Bambus" hardkodet ind i lagen-linjen.
      Efter at tilvalgene er gjort materialeafhaengige stod der derfor
      "Matchende kuvertlagen . Bambus . Hvid" paa et egyptisk saet.

      UDVIDET 31-08-2026: hoer faar nu det EGYPTISKE kuvertlagen tilbudt, fordi
      der ikke kommer hoerlagner. Skrev vi saettets materialenavn ind som foer,
      ville der staa "Hoer . Hvid . 90x200" paa et lagen der er egyptisk bomuld.
      Derfor spoerger vi foerst nwSgTilvalg.lagenMateriale, som kun svarer naar
      lagenets materiale afviger fra saettets. Ellers som hidtil.

   2) SKJUL FOR HOER: der findes stadig ingen hoerpudebetraek, saa den raekke
      skjules fortsat. Lagen-raekken skjules ikke laengere for hoer.
      nw-sg-tilvalg.js saetter klasserne nw-uden-lagen og nw-uden-pb paa #nwsg.
      CSS med :has() findes ikke i aeldre browsere, saa vi skjuler ogsaa fra JavaScript.

   3) PRIS PAA FRAVALGT LAGEN, tilfoejet 31-08-2026: naar lagenet ikke er valgt til,
      skrev nw-sg-8.js "+0 kr." i stedet for hvad det ville koste. Dyne-linjen viser
      derimod sin pris ogsaa naar den er fravalgt. Et silkelagen til 1.599 kr stod
      altsaa som "+0 kr.", hvilket enten laeses som gratis eller som en fejl. Meldt af
      Mads 31/8 fra et skaermbillede. Vi skriver den rigtige pris ind i stedet.

   HVORFOR EN OBSERVER: guidens klik-handlere kalder refresh(), som gentegner
   #addons uden at gaa gennem renderResult. En hook alene blev overskrevet hver
   gang brugeren klikkede.

   Loekkerisiko: vi skriver kun naar noget faktisk er forkert. Anden runde ser at
   alt allerede staar rigtigt og roerer ikke DOM'en. */
(function(){
  'use strict';

  var startet = false;

  function saetMateriale(){
    try{
      var n = materials[chosen.mat].name || '';
      return n.replace(/\s*sengetøj\s*$/i, '').trim() || n;
    }catch(e){ return ''; }
  }

  /* Lagenets eget materiale, hvis det afviger fra saettets. Ellers saettets. */
  function lagenMateriale(){
    try{
      if(window.nwSgTilvalg && typeof window.nwSgTilvalg.lagenMateriale === 'function'){
        var eget = window.nwSgTilvalg.lagenMateriale(chosen.mat);
        if(eget){ return eget; }
      }
    }catch(e){}
    return saetMateriale();
  }

  function raekke(vaelger){
    var el = document.querySelector('#addons ' + vaelger);
    if(!el){ return null; }
    var p = el;
    while(p && p.parentNode && p.parentNode.id !== 'addons'){ p = p.parentNode; }
    return (p && p.parentNode && p.parentNode.id === 'addons') ? p : null;
  }

  function retNavn(){
    try{
      var navn = lagenMateriale();
      if(!navn){ return; }
      var ad = document.querySelector('#addons [data-a="lagen-toggle"] .ad');
      if(!ad){ return; }
      var dele = ad.textContent.split(' · ');
      if(dele.length < 2 || dele[0].trim() === navn){ return; }
      dele[0] = navn;
      ad.textContent = dele.join(' · ');
    }catch(e){}
  }

  /* Viser hvad lagenet ville koste, ogsaa naar det er fravalgt. */
  function retPris(){
    try{
      if(typeof chosen === 'undefined' || !chosen.lagen || chosen.lagen.on){ return; }
      var ap = document.querySelector('#addons [data-a="lagen-toggle"] .ap');
      if(!ap){ return; }
      var typ = (chosen.lagen.type === 'kuvert') ? 'kuvert' : 'box';
      var pris = 0;
      for(var i = 0; i < lagenSizes.length; i++){
        if(lagenSizes[i].v === chosen.lagen.size){ pris = lagenSizes[i][typ] || 0; break; }
      }
      if(!pris){ return; }
      pris = pris * (chosen.lagen.qty || 1);
      var ny = '+' + String(pris).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
      if(ap.textContent.trim() !== ny){ ap.textContent = ny; }
    }catch(e){}
  }

  function retSkjul(){
    try{
      var host = document.getElementById('nwsg');
      if(!host){ return; }
      var udenLagen = host.classList.contains('nw-uden-lagen');
      var udenPb = host.classList.contains('nw-uden-pb');
      var r1 = raekke('[data-a="lagen-toggle"]');
      var r2 = raekke('[data-a="pb-row"]');
      if(r1){
        var v1 = udenLagen ? 'none' : '';
        if(r1.style.display !== v1){ r1.style.display = v1; }
      }
      if(r2){
        var v2 = udenPb ? 'none' : '';
        if(r2.style.display !== v2){ r2.style.display = v2; }
      }
    }catch(e){}
  }

  function pas(){ retSkjul(); retNavn(); retPris(); }

  function start(){
    if(startet){ return; }
    var box = document.getElementById('addons');
    if(!box){ return; }
    startet = true;
    try{
      new MutationObserver(pas).observe(box, { childList: true, subtree: true, characterData: true });
    }catch(e){}
    pas();
  }

  start();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  window.addEventListener('load', start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();